<template lang="" >

  <div  >
    <div v-if="state.loadingVehicleData">
      <pageLoader :msg='state.loadingVehicleMessage'/>
    </div>
    <div class="formWizard row mt-3 formmargin">
      <div class="col-md-6  " >
        <div class="formobileview flex-wrap" >
          <div class="headingcards d-flex gap-3 justify-content-between align-items-center" > 
            <div>
              <h6 class="mb-2" v-if="motorProductType==='4W-Pvt'">CAR DETAILS</h6>
            <h6 class="mb-2" v-if="motorProductType==='2W-Pvt'">BIKE DETAILS</h6>
                <!-- <p class="mb-0" >{{this.state}} {{this.city}} {{this.rtoCode}}</p> -->
            <p class="mb-0 d-flex flex-wrap gap-2" > 
              <span v-if="state.formData.rtoCode">{{state.formData.rtoCode}} ({{state.formData.city?.toUpperCase()}})&nbsp;&nbsp;|</span>
              <span v-if="state.formData.carMake.makeDescription">{{state.formData.carMake.makeDescription.toUpperCase()}}&nbsp;&nbsp;|</span>
              <span v-if="state.formData.model.modelDesc">{{state.formData.model.modelDesc.toUpperCase()}}&nbsp;&nbsp;| </span> 
              <span v-if="state.formData.variant.variantDesc">{{(state.formData.variant.variantDesc).toUpperCase()}}&nbsp;&nbsp;| </span> 
              <span v-if="state.formData.fuelType">{{state.formData.fuelType.toUpperCase()}} </span> 
            </p>  
            </div>
            <div @click="openModalForVehicle()">
              <span class="editform" ><img src="../../assets/images/edit.svg"  />Edit</span>
            </div>
          </div>
        <ul
          class="nav nav-tabs d-block justify-content-left border-0"
          id="myTab"
          role="tablist"
        >
          <li
            v-for="(step, index) in state.steps"
            :key="index"
            class="nav-item"
            role="presentation"
            data-bs-placement="top"
            :title="step.title"
            :class="{ completed: isCompleted(index), 'isLastChild': index == state.steps.length-1 }"
          >
            <div class="d-flex justify-content-between">
              <a
              :class="[
                'd-flex',
                'align-items-center',
                'justify-content-between hovereffect',
                'gap-2 position-relative',
                { active: state.activeTab === index },
              ]"
              @click="selectTab(index)"
              role="tab"
              :aria-controls="'step' + (index + 1)"
              :aria-selected="state.activeTab === index"
              style="width: fit-content"
            >
            <!-- v-html="step.subcontent -->
              <i class="activeicon">{{ step.icon }}</i>
              <div class="checkincon">
                <img src="../../assets/images/check.svg" />
                   
                  </div>
              <p class="mb-0" v-if="state.motorProductType==='4W-Pvt'" v-html="step.carsubcontent "></p>
              <p class="mb-0" v-if="state.motorProductType==='2W-Pvt'" v-html="step.bikesubcontent "></p>
            </a>
            
            </div>
          </li>
        </ul>
        </div>
      </div>

      <div class="tab-content col-md-6" id="myTabContent">
        <div class="d-flex justify-content-between gap-2 mb-2 align-items-center"  >
        <div class="d-flex gap-2 align-items-center">
          <div class="iconback" @click=previousStep() >
          <img src="/images/backarrow.svg" width="15px" class="selectrtosvg" />
        </div>
        <div>
          <p class="m-0 activestepheader" v-if="state.motorProductType==='4W-Pvt'" v-html="activeCarStepContent" style="font-size:14px; font-weight:600"></p>

          <p class="m-0 activestepheader" v-if="state.motorProductType==='2W-Pvt'" v-html="activeBikeStepContent" style="font-size:14px; font-weight:600"></p>

        </div>
        </div>
        <div class="iconback" @click="nextStepIfCompleted()" :class="{ 'disabled-icon': !canMoveForward() }">
          <img src="/images/forwardarrow.svg"  width="15px" class="selectrtosvg" />
        </div>
      
      </div>
        <div
          v-for="(step, index) in state.steps"
          :key="'content-' + index"
          :class="[
            'tab-pane',
            'fade',
            { show: state.activeTab === index, active: state.activeTab === index },
          ]"
          role="tabpanel"
          :id="'step' + (index + 1)"
          :aria-labelledby="'step' + (index + 1) + '-tab'"
        >
       
          <div>
            <CardLoader v-if="state.loadingState"/>
            <component v-else
              :is="step.SelectComponent"
              :data="step.alldata"
              :carplaceholder="step.carplaceholder"
              :bikeplaceholder="step.bikeplaceholder"
              :carexample="step.carexample"
              :bikeexample="step.bikeexample"
              :view="step.view"
              :showOdSection="state.showOdSection"
              :showTpSection="state.showTpSection"
              :showPreviousExpiry="state.showPreviousExpiry"
              :percentOptions="state.percentOptions"
              @item-clicked="handleItemClicked"
              :displayStepData="step.displayStepData"
              :selectedItem="step.selectedItem"
              :selectedItemvalue="step.selectedItemvalue"
              :sessionUserData="state.userData"
              name="Single-Quote"
            />
           
          </div>
          <div
            class="d-flex mt-3 justify-content-between"
            :class="{
              'justify-content-between':
                index !== 0 && index !== state.steps.length - 1,
              'justify-content-end': index === 0,
              'justify-content-between': index === state.steps.length - 1,
            }"
          >  
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <editVehicleDetails></editVehicleDetails> -->
  <ModalVehicleEditing v-if="state.openModalForVehicleEditing" @closeModalEditing="closeModalEditing" @selectTabFromModal="selectTabFromModal"/>
</template>
<script>
import { computed, onMounted, reactive } from "vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import pageLoader from "../pageLoaders/pageLoader.vue";
import SelectRTO from "../selectCard/vehicleDetails.vue";
import CardLoader from "../pageLoaders/cardLoader.vue";
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import backendApi from "@/apis/axios-backend";
// import editVehicleDetails from "@/modals/editVehicleDetails.vue";
import ModalVehicleEditing from "@/modals/ModalVehicleEditing.vue";



export default {
  name: "formWizard",
  props: {
    msg: String,
  },
  components:{
    SelectRTO,
    pageLoader,
    CardLoader,
    // editVehicleDetails,
    ModalVehicleEditing
  }, 
  
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    let state = reactive({
      activeTab: 0,
      loadingVehicleData: false,
      loadingVehicleMessage: "",
      quoteCategory:'', 
      openModalForVehicleEditing: false,
      steps:[
    {
        title: "Step 1",
        icon: "1",
        carsubcontent: ' Choose <b>State</b>',
        bikesubcontent: ' Choose <b>State</b>',
        carplaceholder: 'Search State',
        bikeplaceholder: 'Search State',
        displayStepData: "state",
        carexample:"Maharashtra, Delhi" ,
        bikeexample:"Maharashtra, Delhi" ,
        SelectComponent: SelectRTO,
        searchData: "userData.state",
        alldata:[],
        iscompleted:false,
        view: "vehicleDetails",
        selectedItem:"state",
        selectedItemvalue:"",
        
      },
    {
        title: "Step 2",
        icon: "2",
        carsubcontent: ' Choose <b>City</b>',
        bikesubcontent: ' Choose <b>City</b>',
        carplaceholder: 'Search City',
        bikeplaceholder: 'Search City',
        displayStepData: "city",
        carexample: "Pune",
        bikeexample: "Pune",
        SelectComponent: SelectRTO,
        searchData: "userData.city",
        alldata:[],
        iscompleted:false,
        view: "vehicleDetails",
        selectedItem:"city",
        selectedItemvalue:"",


      },
      {
        title: "Step 3",
        icon: "3",
        carsubcontent: ' Choose  <b>RTO</b>',
        bikesubcontent: ' Choose  <b>RTO</b>',
        carplaceholder: 'Search RTO',
        bikeplaceholder: 'Search RTO',
        displayStepData: "rtoCode",
        carexample: "MH-12, MH-14",
        bikeexample: "MH-12, MH-14",
        SelectComponent: SelectRTO,
        searchData: "userData.rto",
        alldata:[],
        iscompleted:false,
        view: "vehicleDetails",
        selectedItem:"rtoCode",
        selectedItemvalue:"",

        

      },
      {
        title: "Step 4",
        icon: "4",
        carsubcontent: "Choose  <b> Car Make</b>",
        bikesubcontent: "Choose  <b> Bike Make</b>",
        carplaceholder: 'Search Car Make',
        bikeplaceholder: 'Search Bike Make',
        SelectComponent: SelectRTO,
        displayStepData: "carMake",
        carexample: "Hyundai",
        bikeexample: "Suzuki",
        alldata:[],
        iscompleted:false,
        view: "vehicleDetails",
        selectedItem:"carMake",
        selectedItemvalue:"",



      },
      {
        title: "Step 5",
        icon: "5",
        carsubcontent: "Choose <b>Car Model</b>",
        bikesubcontent: "Choose <b>Bike Model</b>",
        carplaceholder: 'Search Car Model',
        bikeplaceholder: 'Search Bike Model',
        SelectComponent: SelectRTO,
        displayStepData: "model",
        carexample: "Creta",
        bikeexample: "Access",
        alldata:[],
        iscompleted:false,
        view: "vehicleDetails",
        selectedItem:"model",
        selectedItemvalue:"",

      },
      {
        title: "Step 6",
        icon: "6",
        carsubcontent: "Choose <b>Car Fuel Type</b>",
        bikesubcontent: "Choose <b>Bike Fuel Type</b>",
        SelectComponent: SelectRTO,
        carplaceholder: 'Select Car Fuel Type',
        bikeplaceholder: 'Select Bike Fuel Type',
        displayStepData: "fuelType",
        carexample: "petrol",
        bikeexample: "petrol",
        alldata:[],
        iscompleted:false,
        view: "vehicleDetails",
        selectedItem:"fuelType",
        selectedItemvalue:"",

      },
      {
        title: "Step 7",
        icon: "7",
        carsubcontent: "Choose <b>Car Variant</b>",
        bikesubcontent: "Choose <b>Bike Variant</b>",
        carplaceholder: 'Search Car Variant',
        bikeplaceholder: 'Search Bike Variant',
        SelectComponent: SelectRTO,
        displayStepData: "variant",
        carexample: "Prime Era T CRDI (1120 CC)",
        bikeexample: "Disk Break",
        alldata:[],
        iscompleted:false,
        view: "vehicleDetails",
        selectedItem:"variant",
        selectedItemvalue:"",

      },
      {
        title: "Step 8",
        icon: "8",
        carsubcontent: "<b>Additional</b> Details",
        bikesubcontent: "<b>Additional</b> Details",
        SelectComponent: SelectRTO ,
        carplaceholder: 'Additonal Details',
        bikeplaceholder: 'Additonal Details',
        displayStepData: "additonalDetails",
        carexample: "",
        bikeexample: "",
        alldata:[],
        iscompleted:false,
        view: "additonalDetails",
        selectedItem:"",


      },
      {
        title: "Step 9",
        icon: "9",
        carsubcontent: store.state.quoteCategory=='Roll-Over' ? "Previous Policy Details" : "Personal Informations",
        bikesubcontent: store.state.quoteCategory=='Roll-Over' ? "Previous Policy Details" : "Personal Informations",
        SelectComponent: SelectRTO  ,
        iscompleted:false,
        displayStepData: "claim",
        carexample: "",
        bikeexample: "",
        alldata:[],
        view: "claim",
        selectedItem:"",
      },
      ],
      indexForActiveTab:"",
      motorProductType:'',
      allRtoDetails:[],
      userData:{},
      loadingMsg:"Please wait while we are fetching the data",
      loadingState:true,
      category:"rto",
      reqBody:{},
      itemClicked:"",
      vehicleKey:"",
      registrationYear:"",
      percentOptions:[],
      showOdSection: true,
      showTpSection: true,
      showPreviousExpiry: true,
      vehicleAge:null,
      searchfromhandlebutton:false,
      formData: {
        state:"",
        city:"",
        rtoCode:"",
        makeCode:"",
        model:"",
        fuelType:"",
        variant: "",
        vehicleType:"",
        carMake:''

      },
      formAlldata:[{ state: [] },
    { city: [] },
    { rtoCode: [] },
    { carMake: [] },
    { model: [] },
    { fuelType: [] },
    { variant: [] },
    { makeCode: [] }],

      formDataIndex : [{ state: "" },
    { city: "" },
    { rtoCode: "" },
    { carMake: '' },
    { model: "" },
    { fuelType: "" },
    { variant: "" },
    { makeCode: "" }
   ]
    })
    onMounted(()=>{
      sessionStorage.removeItem('user-type');
      state.quoteCategory = store.state.quoteCategory;
      state.userData = JSON.parse(sessionStorage.getItem("userData"));
      state.motorProductType=store.state.motorProductType;
      if(state.quoteCategory!="New"){
        state.loadingVehicleData =true;
        handleVahanApi();
      }
      if(sessionStorage.getItem("rtoCode")){
        const rtoCode=JSON.parse(sessionStorage.getItem("rtoCode"));
        if(rtoCode){
          // const rtoCode=JSON.parse(sessionStorage.getItem("rtoCode"));
          state.formData["rtoCode"] =rtoCode;
          state.itemClicked="rtoCode"
        state.reqBody= {
          category: "rto",
          rtoCode:rtoCode ,
        }
          backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ store.state.token}`}, "get", {}, state.reqBody)
            .then((response) => {
              const rtoLookupErrors = response?.data?.errors;
              if (Array.isArray(rtoLookupErrors) && rtoLookupErrors.length > 0) {
                const msg = [];
                if(rtoLookupErrors[0].errorDisplayMsg !=""){
                msg.push(rtoLookupErrors[0].errorDisplayMsg);
                }
                
              }  else if(response && response.data) {  
            for(let i=0;i<4;i++){
            state.steps[i].iscompleted = true; 
          }   
          selectTab(3);
          const statelist=[];
          const city=[];
          const rto=[];
          statelist.push(response.data.data.rto[0].state);
          city.push(response.data.data.rto[0].city);
          rto.push(rtoCode);
          state.formData["state"] =response.data.data.rto[0].state;
          state.formData["city"] =response.data.data.rto[0].city;
          state.steps[0].selectedItemvalue=response.data.data.rto[0].state;
          state.steps[1].selectedItemvalue=response.data.data.rto[0].city;
          state.steps[2].selectedItemvalue=rtoCode;
          if(state.motorProductType =="4W-Pvt"){
            state.steps[0].carplaceholder = state.steps[0].selectedItemvalue;
            state.steps[1].carplaceholder = state.steps[1].selectedItemvalue;
            state.steps[2].carplaceholder = state.steps[2].selectedItemvalue;
          }
            else if(state.motorProductType == "2W-Pvt"){
            state.steps[0].bikeplaceholder = state.steps[0].selectedItemvalue;
            state.steps[1].bikeplaceholder = state.steps[1].selectedItemvalue;
            state.steps[2].bikeplaceholder = state.steps[2].selectedItemvalue;

          }
          state.steps[0].alldata=statelist;
          state.steps[1].alldata=city;
          state.steps[2].alldata=rto;
          state.formAlldata[0]["state"]=statelist;
          state.formAlldata[1]["city"]=city;
          state.formAlldata[2]["rtoCode"]=rto;
          state.formDataIndex[0].state=response.data.data.rto[0].state;
          state.formDataIndex[1].city=response.data.data.rto[0].city;
          state.formDataIndex[2].rtoCode=rtoCode;
          state.userData["state"] =response.data.data.rto[0].state;
          state.userData["city"] =response.data.data.rto[0].city;
          state.userData['pinCode']=response.data.data.rto[0].zipCode;
          state.userData["rtoCode"] =rtoCode;
          //  handleVahanApi();
          sessionStorage.setItem("userData",JSON.stringify(state.userData));
          }
      }).catch((error) => {
            const msg = "Service is Unavailable, Please try again later.";
            router.push({ path: '/error-page', query: { backUrl:'New-Journey', msg: msg,reqid:response?.data?.reqId } });
          });
    
        }
      }
  //  const pollingSingle =  sessionStorage.getItem("singleQuotePollIntervalID")
   
      if(sessionStorage.getItem("userData")){
        
        const parsedData=JSON.parse(sessionStorage.getItem("userData"));
        
        if (parsedData.RegDate) {
          for (let i = 0; i<9; i++) {
        state.steps[i].iscompleted = true;  
      }
          state.percentOptions=parsedData.percentOptions
            selectTab(8);
        }
      }
       //get index for active tab
      // state.indexForActiveTab= route.query.index;
      state.indexForActiveTab= JSON.parse(sessionStorage.getItem("edit"));
      sessionStorage.removeItem('edit')
      if(state.indexForActiveTab){
        for (let i = state.indexForActiveTab ; i >=0; i--) {
        state.steps[i].iscompleted = true;  
      }
      var indexint = parseInt(state.indexForActiveTab, 10);
      
      selectTab(indexint);
      }
      //getting alldata from session
      if(sessionStorage.getItem("formAlldata")){
      state.formAlldata=JSON.parse(sessionStorage.getItem("formAlldata"))
      state.steps[0].alldata=state.formAlldata[0]["state"];
      state.steps[1].alldata=state.formAlldata[1]["city"];
      state.steps[2].alldata=state.formAlldata[2]["rtoCode"];
      state.steps[3].alldata=state.formAlldata[3]["carMake"];
      state.steps[4].alldata=state.formAlldata[4]["model"];
      state.steps[5].alldata=state.formAlldata[5]["fuelType"];}
      state.steps[6].alldata=state.formAlldata[6]["variant"];
      
      if(sessionStorage.getItem("userSelection")){
        state.formDataIndex=JSON.parse(sessionStorage.getItem("userSelection"));
        const seletditem=  JSON.parse(sessionStorage.getItem("userSelection"))
        state.steps[0].selectedItemvalue=seletditem[0].state;
        state.steps[1].selectedItemvalue=seletditem[1].city;
        state.steps[2].selectedItemvalue=seletditem[2].rtoCode;
        state.steps[3].selectedItemvalue=seletditem[3]["carMake"];
        console.log("--sec value",seletditem[3]["carMake"]);
        state.steps[4].selectedItemvalue=seletditem[4]["model"];
        state.steps[5].selectedItemvalue=seletditem[5]["fuelType"];
        state.steps[6].selectedItemvalue=seletditem[6]["variant"];
        sessionStorage.removeItem("userSelection");
        if(state.indexForActiveTab>3){
          state.category='vehicle';
        }
         //adding itemclicked
         if(state.indexForActiveTab>0){
          state.itemClicked=state.steps[state.indexForActiveTab-1].displayStepData;
         }
        
        const pickedValues = state.formDataIndex.slice(0,state.indexForActiveTab);
        pickedValues.forEach(obj => {
      const key = Object.keys(obj)[0]; // Extract the key from the object
      if (key in state.formData) {
        state.formData[key] = obj[key]; // Update the formData with the value
      }
    });
      }
      if(sessionStorage.getItem("userData")){
      state.userData = JSON.parse(sessionStorage.getItem("userData"));
      }
      state.category="rto"
      state.loadingState=true;   

      searchVehicle();
      delete state.userData.prePolicyGreaterThan90Days;
      sessionStorage.setItem('userData', JSON.stringify(state.userData));
      sessionStorage.removeItem("motor_covers");
      sessionStorage.removeItem("selectedUniqueAddons");
      sessionStorage.removeItem("quote_request");
      sessionStorage.removeItem("plansWithAddons");
      sessionStorage.removeItem("idvValues");
      sessionStorage.removeItem("paCvrAddedFirstTime");
      sessionStorage.removeItem("ownershipTransferCheck");
      delete state.userData.idvSelector;
      sessionStorage.setItem("userData", JSON.stringify(state.userData));
    })
    
    const currentYearCalculated = computed(()=>{
      return new Date().getFullYear();
    })
    // const vehicleAge = computed(()=>{
    //   return this.currentYear - this.registrationYear;
    // })
    
    function completed(index) {
      state.activeTab = index;
    }
    function handleVahanApi(){
      try {
        const vahanDataStore = JSON.parse(sessionStorage.getItem("vahanData"));
        state.loadingVehicleData = true;
        state.loadingVehicleMessage = "Getting Vahan Data"
        if(vahanDataStore) {        
          // Extract all details from response
          const vehicleDetails = vahanDataStore.vehicleDetails;
          const regDetails = vahanDataStore.registrationDetails;
          const previousPolicyDetails = vahanDataStore.previousPolicyDetails;

          // Use makeCode and modelCode from response if available, otherwise use defaults
          const makeCode = vehicleDetails.vehicleMakeCode; // Default makeCode if not available
          const modelCode = vehicleDetails.vehicleModelCode;  // Default modelCode if not available
          const vehicleFuelType = vehicleDetails.vehicleFuelType;
          const vehicleVariantCode = vehicleDetails.vehicleVariantCode;
          
          // Update userData with registration details
          state.userData = JSON.parse(sessionStorage.getItem("userData")) || {};
          state.userData.RegDate = regDetails.registrationDate;
          state.userData.MfgYear = regDetails.manufacturingYear || (new Date(regDetails.registrationDate)).getFullYear();
          state.registrationYear = state.userData.MfgYear; // Set for NCB calculations
          
          // Store previous policy details if available
          if (previousPolicyDetails) {
            if (previousPolicyDetails.previousPolicyEndDate) {
              state.userData.OdDate = previousPolicyDetails.previousPolicyEndDate;
            }
            
            if (previousPolicyDetails.previousPolicyInsurer) {
              state.userData.previousPolicyInsurer = previousPolicyDetails.previousPolicyInsurer;
            }
            
            // If there are separate OD and TP dates
            if (previousPolicyDetails.previousPolicyOdExpiryDate) {
              state.userData.OdDate = previousPolicyDetails.previousPolicyOdExpiryDate;
            }
            
            if (previousPolicyDetails.previousPolicyTpExpiryDate) {
              state.userData.TpDate = previousPolicyDetails.previousPolicyTpExpiryDate;
            }
          }
          
          sessionStorage.setItem("userData", JSON.stringify(state.userData));
          
          // Mark steps 7 and 8 as completed since we'll auto-populate them
          state.steps[7].iscompleted = true; // Additional details step
          
          // Set loading state for API calls
          state.loadingState = true;
          
          // 1. First, get the make list (Step 4)
          getMakeList(makeCode, modelCode, vehicleFuelType, vehicleVariantCode);
        }else{
          state.loadingVehicleData = false;
          state.loadingVehicleMessage = ""
        }
      } catch (error) {
        console.error("Error in Vahan API:", error);
        state.loadingState = false;
        state.loadingVehicleData = false;
        state.loadingVehicleMessage = ""
      }
    }
    
    // Helper function to process the make data and move to the next step
    async function getMakeList(makeCode, modelCode, vehicleFuelType, vehicleVariantCode) {
      try {
        state.loadingVehicleData = true;
        state.loadingVehicleMessage = "Getting Vehicle Make"
        state.category = 'vehicle';
        state.reqBody = {
          category: 'vehicle',
          vehicleType: state.motorProductType === '4W-Pvt' ? '1' : '2'
        };
        
        const response = await backendApi("vehicleSearch", [], {"Authorization":`Bearer ${store.state.token}`}, "get", {}, state.reqBody);
        
        if(response && response.data && response.data.data.make) {
          // Find the matching make from the list using makeCode
          let matchedMake = response.data.data.make.find(item => item.makeCode == makeCode);
          if(matchedMake) {
            // Store the make data in the steps
            state.steps[3].alldata = response.data.data.make;
            state.formAlldata[3]["carMake"] = response.data.data.make;
            
            // Use handleItemClicked to ensure proper step progression
            const makeItem = {
              key: "carMake",
              value: matchedMake,
              selectedDate: "",
              selectedYear: "",
              selectionChanged: true
            };
            
            // Call handleItemClicked to process the selection and move to next step
            handleItemClicked(makeItem);
            
            // Add slight delay before continuing to next API call
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // Continue to next step - model list
            await getModelList(makeCode, modelCode, vehicleFuelType, vehicleVariantCode);
          } else {
            state.steps[3].alldata = response.data.data.make;
            state.formAlldata[3]["carMake"] = response.data.data.make;
            // No matching make found, display the list for manual selection
            state.loadingState = false;
            state.loadingVehicleData = false;
            state.loadingVehicleMessage = ""
            selectTab(3);
          }
        } else {
          state.loadingState = false;
          state.loadingVehicleData = false;
          state.loadingVehicleMessage = "";
          selectTab(3);
        }
      } catch (error) {
        console.error("Error fetching make list:", error);
        state.loadingState = false;
        state.loadingVehicleData = false;
        state.loadingVehicleMessage = ""
        selectTab(3);
      }
    }
    
    // Helper function to process the model data and move to the next step
    async function getModelList(makeCode, modelCode, vehicleFuelType, vehicleVariantCode) {
      try {
        state.loadingVehicleData = true;
        state.loadingVehicleMessage = "Getting Vehicle Model"
        state.category = 'vehicle';
        state.reqBody = {
          category: 'vehicle',
          vehicleType: state.motorProductType === '4W-Pvt' ? '1' : '2',
          make: makeCode
        };
        
        const response = await backendApi("vehicleSearch", [], {"Authorization":`Bearer ${store.state.token}`}, "get", {}, state.reqBody);
        
        if(response && response.data && response.data.data.model) {
          // Find the matching model from the list using modelCode
          const matchedModel = response.data.data.model.find(item => item.modelCode == modelCode);
          
          if(matchedModel) {
            // Store the model data in the steps
            state.steps[4].alldata = response.data.data.model;
            state.formAlldata[4]["model"] = response.data.data.model;
            
            // Use handleItemClicked to ensure proper step progression
            const modelItem = {
              key: "model",
              value: matchedModel,
              selectedDate: "",
              selectedYear: "",
              selectionChanged: true
            };
            
            // Call handleItemClicked to process the selection and move to next step
            handleItemClicked(modelItem);
            
            // Add slight delay before continuing to next API call
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // Continue to next step - fuel type list
            await getFuelTypeList(makeCode, modelCode, vehicleFuelType, vehicleVariantCode);
          } else {
            state.steps[4].alldata = response.data.data.model;
            state.formAlldata[4]["model"] = response.data.data.model;
            // No matching model found, display the list for manual selection
            state.loadingState = false;
            state.loadingVehicleData = false;
            state.loadingVehicleMessage = "";
            selectTab(4);
          }
        } else {
          state.loadingState = false;
          state.loadingVehicleData = false;
          state.loadingVehicleMessage = "";
          selectTab(4);
        }
      } catch (error) {
        console.error("Error fetching model list:", error);
        state.loadingState = false;
        state.loadingVehicleData = false;
        state.loadingVehicleMessage = ""
        selectTab(4);
      }
    }
    
    // Helper function to process the fuel type data and move to the next step
    async function getFuelTypeList(makeCode, modelCode, vehicleFuelType, vehicleVariantCode) {
      try {
        state.loadingVehicleData = true;
        state.loadingVehicleMessage = "Getting Vehicle Fuel"
        state.category = 'vehicle';
        state.reqBody = {
          category: 'vehicle',
          vehicleType: state.motorProductType === '4W-Pvt' ? '1' : '2',
          make: makeCode,
          model: modelCode
        };
        
        const response = await backendApi("vehicleSearch", [], {"Authorization":`Bearer ${store.state.token}`}, "get", {}, state.reqBody);
        
        if(response && response.data && response.data.data.fuelType) {
          // Extract fuel types
          const fuelTypes = response.data.data.fuelType.map(item => item.fuelType);
          
          // Find the matching fuel type from the list
          const matchedFuel = fuelTypes.find(fuel => 
            fuel.toLowerCase() === (vehicleFuelType || '').toLowerCase()
          );
          
          // Store fuel type data
          state.steps[5].alldata = fuelTypes;
          state.formAlldata[5]["fuelType"] = fuelTypes;
          
          if(matchedFuel) {
            // Use handleItemClicked to ensure proper step progression
            const fuelItem = {
              key: "fuelType",
              value: matchedFuel,
              selectedDate: "",
              selectedYear: "",
              selectionChanged: true
            };
            
            // Call handleItemClicked to process the selection and move to next step
            handleItemClicked(fuelItem);
            
            // Add slight delay before continuing to next API call
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // Continue to next step - variant list
            await getVariantList(makeCode, modelCode, matchedFuel, vehicleVariantCode);
          } else if(fuelTypes.length === 1) {
            // If there's only one fuel type, select it automatically
            const fuelItem = {
              key: "fuelType",
              value: fuelTypes[0],
              selectedDate: "",
              selectedYear: "",
              selectionChanged: true
            };
            
            // Call handleItemClicked to process the selection and move to next step
            handleItemClicked(fuelItem);
            
            // Add slight delay before continuing to next API call
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // Continue to next step - variant list
            await getVariantList(makeCode, modelCode, fuelTypes[0], vehicleVariantCode);
          } else {
            // Multiple fuel types and no match, display the list for manual selection
            state.loadingState = false;
            state.loadingVehicleData = false;
            state.loadingVehicleMessage = "";
            selectTab(5);
          }
        } else {
          state.loadingState = false;
          state.loadingVehicleData = false;
          state.loadingVehicleMessage = "Getting Vehicle Make"
          selectTab(5);
        }
      } catch (error) {
        console.error("Error fetching fuel type list:", error);
        state.loadingState = false;
        selectTab(5);
      }
    }
    
    // Helper function to process the variant data and move to the next step
    async function getVariantList(makeCode, modelCode, fuelType, vehicleVariantCode) {
      try {
        state.loadingVehicleData = true;
        state.loadingVehicleMessage = "Getting Vehicle Variant"
        state.category = 'vehicle';
        state.reqBody = {
          category: 'vehicle',
          vehicleType: state.motorProductType === '4W-Pvt' ? '1' : '2',
          make: makeCode,
          model: modelCode,
          fuelType: fuelType
        };
        
        const response = await backendApi("vehicleSearch", [], {"Authorization":`Bearer ${store.state.token}`}, "get", {}, state.reqBody);
        
        if(response && response.data && response.data.data.variant) {
          // Find the matching variant from the list using variantCode
          const matchedVariant = response.data.data.variant.find(item => 
            item.variantCode == vehicleVariantCode
          );
          
          // Store variant data
          state.steps[6].alldata = response.data.data.variant;
          state.formAlldata[6]["variant"] = response.data.data.variant;
          
          if(matchedVariant) {
            // Use handleItemClicked to ensure proper step progression
            const variantItem = {
              key: "variant",
              value: matchedVariant,
              selectedDate: "",
              selectedYear: "",
              selectionChanged: true
            };
            
            // Call handleItemClicked to process the selection and move to next step
            handleItemClicked(variantItem);
            selectTab(6)
            // Check for vehicleKey
            if(response.data.data.vehicleKey && response.data.data.vehicleKey.length > 0) {
              state.vehicleKey = response.data.data.vehicleKey[0].vehicleKey;
              state.userData.vehicleKey = state.vehicleKey;
              sessionStorage.setItem("vehicleKey",JSON.stringify(state.vehicleKey));
              sessionStorage.setItem("userData", JSON.stringify(state.userData));
            }
            
            // Add slight delay before moving to additional details
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // We've reached the end of the vehicle details, move to additional details
            // and auto-populate the registration date
            state.loadingState = false;
            state.loadingVehicleData = false;
            state.loadingVehicleMessage = ""
            
            // Create additional details item with registration date
            if(state.userData.RegDate) {
              const additionalDetailsItem = {
                key: "additonalDetails",
                value: "",
                selectedDate: state.userData.RegDate,
                selectedYear: state.userData.MfgYear || (new Date(state.userData.RegDate)).getFullYear(),
                selectionChanged: true
              };
              
              // Process the additional details
              handleItemClicked(additionalDetailsItem);
              
              // Set NCB-related fields for the claim step
              state.showOdSection = displayODSection();
              state.showTpSection = displayTPSection();
              state.showPreviousExpiry = isPreviousExpiryDate();
              state.percentOptions = getNCBGridValue();
              
              // Mark additional details step as completed
              state.steps[7].iscompleted = true;
              
              // Add slight delay before going to claim step
              await new Promise(resolve => setTimeout(resolve, 300));
              
              // Skip to the claim step (last step)
              selectTab(8);
            } else {
              // If no registration date, just go to additional details step
              selectTab(7);
            }
          } else {
            // No matching variant found, display the list for manual selection
            state.loadingState = false;
            state.loadingVehicleData = false;
            state.loadingVehicleMessage = ""
            selectTab(6);
          }
        } else {
          state.loadingState = false;
          state.loadingVehicleData = false;
          state.loadingVehicleMessage = "";
          selectTab(6);
        }
      } catch (error) {
        console.error("Error fetching variant list:", error);
        state.loadingState = false;
        state.loadingVehicleData = false;
        state.loadingVehicleMessage = ""
        selectTab(6);
      }
      
      // Save form data to sessionStorage
      sessionStorage.setItem("formAlldata", JSON.stringify(state.formAlldata));
    }

    function getVehicleMakeList(makeCode, modelCode, vehicleFuelType, vehicleVariantCode){
      // This function is replaced by the new approach
      state.loadingState=true;
      state.category = 'vehicle';
      state.reqBody= {
        category: state.category,
        state: state.category === 'vehicle' ? '' : state.formData.state,
        city: state.category === 'vehicle' ? '' : state.formData.city,
        rtoCode: state.category === 'vehicle' ? '' : state.formData.rtoCode,
        vehicleType: state.category === 'vehicle' ? (state.motorProductType === '4W-Pvt' ? '1' : '2'):'',
        make: makeCode,
      }

    backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ store.state.token}`}, "get", {}, state.reqBody)
      .then((response) => {
        // state.steps
        state.itemClicked ="rtoCode";
        state.allRtoDetails = [];

        if(response && response.data) {
          response.data.data.model.forEach(model => {
            state.allRtoDetails.push(model);
          })
          state.steps[4].alldata=state.allRtoDetails;
          state.steps[3].iscompleted=true;
          selectTab(5);
          let item = {
            key: "model",
            selectedDate: "",
            selectedYear: "",
            selectionChanged:true,
            value: state.steps[4].selectedItemvalue
          }
          handleItemClicked(item);
          getVehicleModelList(makeCode, modelCode, vehicleFuelType, vehicleVariantCode);
        }
      })
    }

    function getVehicleModelList(make, model, fuel, variant){
      // This function is replaced by the new approach
      state.loadingState=true;
      state.category = 'vehicle';
      state.reqBody= {
        category: state.category,
        state: state.category === 'vehicle' ? '' : state.formData.state,
        city: state.category === 'vehicle' ? '' : state.formData.city,
        rtoCode: state.category === 'vehicle' ? '' : state.formData.rtoCode,
        vehicleType: state.category === 'vehicle' ? (state.motorProductType === '4W-Pvt' ? '1' : '2'):'',
        make: make,
        model: model,
      }

    backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ store.state.token}`}, "get", {}, state.reqBody)
      .then((response) => {
        // state.steps
        state.itemClicked ="rtoCode";
        state.allRtoDetails = [];

        if(response && response.data) {
          response.data.data.fuelType.forEach(fuel => {
            state.allRtoDetails.push(fuel);
          })
          state.steps[5].alldata=state.allRtoDetails;
          state.steps[4].iscompleted=true;
          selectTab(6);
          let item = {
            key: "fuelType",
            selectedDate: "",
            selectedYear: "",
            selectionChanged:true,
            value: state.steps[5].selectedItemvalue
          }
          handleItemClicked(item);
          getVehicleFuelTypeList(make, model, fuel, variant);
        }
      })
    }

    function getVehicleFuelTypeList(make, model, fuel, variant){
      // This function is replaced by the new approach
      state.loadingState=true;
      state.category = 'vehicle';
      state.reqBody= {
        category: state.category,
        state: state.category === 'vehicle' ? '' : state.formData.state,
        city: state.category === 'vehicle' ? '' : state.formData.city,
        rtoCode: state.category === 'vehicle' ? '' : state.formData.rtoCode,
        vehicleType: state.category === 'vehicle' ? (state.motorProductType === '4W-Pvt' ? '1' : '2'):'',
        make: make,
        model: model,
        fuelType: fuel
      }

    backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ store.state.token}`}, "get", {}, state.reqBody)
      .then((response) => {
        // state.steps
        state.itemClicked ="fuelType";
        state.allRtoDetails = [];

        if(response && response.data) {
          response.data.data.variant.forEach(fuel => {
            state.allRtoDetails.push(fuel);
          })
          state.steps[6].alldata=state.allRtoDetails;
          state.steps[5].iscompleted=true;
          // getVehicleFuelTypeList(make, model, fuel, variant);
        }
      })
    }

    function handleItemClicked(item){
     state.searchfromhandlebutton=true;
     state.itemClicked = item.key;
     state.registrationYear= item.selectedYear;
     const {key, value, selectedDate, selectionChanged} = item;
     console.log("handleItemClicked", item, key, value, selectedDate, selectionChanged)
      
     if(key==="state"){
       state.formData= {
       state:"",
       city:"",
       rtoCode:"",
       makeCode:"",
       model:"",
       fuelType:"",
       variant: "",
       vehicleType:"",
       carMake:''
     },
     state.category="rto";
     }
     
     // Store the current value
     state.formData[key] = value;
     
     // Only clear next steps if selection has changed
     if (selectionChanged) {
       // Clear next steps based on the current step
       const stepIndex = state.steps.findIndex(step => step.displayStepData === key);
       if (stepIndex !== -1) {
         // Clear all steps after the current one
         for (let i = stepIndex + 1; i < state.steps.length - 1; i++) {
           if (state.steps[i].selectedItem) {
             state.steps[i].selectedItemvalue = '';
             state.formData[state.steps[i].selectedItem] = '';
             state.userData[state.steps[i].selectedItem] = '';
             state.steps[i].iscompleted = false; // Mark step as incomplete
             
             // Reset placeholders for cleared steps
             if (state.motorProductType === '4W-Pvt') {
               if (i === 3) state.steps[i].carplaceholder = 'Search Car Make';
               if (i === 4) state.steps[i].carplaceholder = 'Search Car Model';
               if (i === 5) state.steps[i].carplaceholder = 'Select Car Fuel Type';
               if (i === 6) state.steps[i].carplaceholder = 'Search Car Variant';
             } else if (state.motorProductType === '2W-Pvt') {
               if (i === 3) state.steps[i].bikeplaceholder = 'Search Bike Make';
               if (i === 4) state.steps[i].bikeplaceholder = 'Search Bike Model';
               if (i === 5) state.steps[i].bikeplaceholder = 'Select Bike Fuel Type';
               if (i === 6) state.steps[i].bikeplaceholder = 'Search Bike Variant';
             }
           }
         }
       }
     }
     
     for(var i=0;i<state.steps.length-1;i++){{
      if(state.steps[i].selectedItem==key){
        state.steps[i].selectedItemvalue=value;
        state.steps[i].iscompleted = true; // Mark current step as completed

        // Update placeholders for the current selection
        if(state.motorProductType =="4W-Pvt"){
          if(i === 3 && value && value.makeDescription){
            state.steps[i].carplaceholder = value.makeDescription;
          }
          if(i === 4 && value && value.modelDesc){
            state.steps[i].carplaceholder = value.modelDesc;
          }
          if(i === 5 && value){
            state.steps[i].carplaceholder = value;
          }
          if(i === 6 && value && value.variantDesc){
            state.steps[i].carplaceholder = value.variantDesc;
          }
        }
        else if(state.motorProductType ="2W-Pvt"){
          if(i === 3 && value && value.makeDescription){
            state.steps[i].bikeplaceholder = value.makeDescription;
          }
          if(i === 4 && value && value.modelDesc){
            state.steps[i].bikeplaceholder = value.modelDesc;
          }
          if(i === 5 && value){
            state.steps[i].bikeplaceholder = value;
          }
          if(i === 6 && value && value.variantDesc){
            state.steps[i].bikeplaceholder = value.variantDesc;
          }
        }
        console.log("--first value",value,key);
      }
     }
     }

     // Update formDataIndex with the selected value
     for (let obj of state.formDataIndex) {
       if (key in obj) {
         obj[key] = value; // Update the value
         break; // Exit the loop once the key is found and updated
       }
     }
     sessionStorage.setItem("userSelection", JSON.stringify(state.formDataIndex));

     state.userData = JSON.parse(sessionStorage.getItem("userData"));
     state.userData[key]=value;
     sessionStorage.setItem("userData",JSON.stringify(state.userData));
     var index= state.steps.findIndex(step => step.displayStepData == key);
     if(key=="additonalDetails" && selectedDate==''){
       state.steps[index]['iscompleted']=false;
     }
     else{
       state.steps[index]['iscompleted']=true;
     }
     
     state.loading = true;
     if(state.itemClicked == "additonalDetails"){
       state.showOdSection= displayODSection()
       state.showTpSection= displayTPSection()
       state.showPreviousExpiry= isPreviousExpiryDate()
       state.percentOptions = getNCBGridValue()

       state.loading=false;
       if( state.steps[index]['iscompleted']){
         nextStep();
       }
       
     }
     else
     searchVehicle();
    }

    function checkBHSeries() {
      const fullCurrentYear = new Date().getFullYear();
      const bhSeriesPattern = /^(\d{2})([A-Z]{2})(\d{4})([A-Z]{1,2})$/;
      if(state.userData.vehicleNumber){
        const match = state.userData.vehicleNumber.match(bhSeriesPattern);
        if (!match) {
          return { valid: false, regYear: null };
        }
        const regYearLastTwo = parseInt(match[1], 10);
        const regYearFull = 2000 + regYearLastTwo;
        if (regYearFull < 2021 || regYearFull > fullCurrentYear) {
          return { valid: false, regYear: regYearFull };
        }
        return { valid: true, regYear: regYearFull };
      }
    }
    function searchVehicle(category="rto"){
      state.loadingState=true;
        state.category = state.formData.rtoCode != '' ? 'vehicle' : category;
        state.reqBody= {
          category: state.category,
          state: state.category === 'vehicle' ? '' : state.formData.state,
          city: state.category === 'vehicle' ? '' : state.formData.city,
          rtoCode: state.category === 'vehicle' ? '' : state.formData.rtoCode,
          vehicleType: state.category === 'vehicle' ? (state.motorProductType === '4W-Pvt' ? '1' : '2'):'',
          make: state.category === 'vehicle' ? (state.formData?.carMake?.makeCode || '') : '',
          model: state.category === 'vehicle' ? (state.formData?.model?.modelCode || '') : '',
          fuelType: state.category === 'vehicle' ? (state.formData?.fuelType || '') : '',
          variant: state.category === 'vehicle' ? (state.formData?.variant?.variantCode || '') : '',

        }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ store.state.token}`}, "get", {}, state.reqBody)
        .then((response) => {
          const vehicleSearchErrors = response?.data?.errors;
          if (Array.isArray(vehicleSearchErrors) && vehicleSearchErrors.length > 0) {
            state.loadingState=false;
            const msg = [];
            if(vehicleSearchErrors[0].errorDisplayMsg !=""){
            msg.push(vehicleSearchErrors[0].errorDisplayMsg);
            }
          } else if(response && response.data) {
            if(state.userData.vehicleNumber && checkBHSeries().valid && state.itemClicked == ""){
              sessionStorage.setItem("all-rto", JSON.stringify(response.data.data.rto))
            }
            if(state.quoteCategory=="New" && state.itemClicked ==""){
              sessionStorage.setItem("all-rto", JSON.stringify(response.data.data.rto))
            }
            state.loadingState=false;
          if(state.steps[0].displayStepData == "state" && state.formData.state =="" && state.formData.rtoCode ==""){
            state.allRtoDetails = [];
            response?.data?.data?.rto.forEach(rto => {
              if (rto && rto.state) {
                state.allRtoDetails.push(rto);
              }
            });
            const uniqueStates = [...new Set(
              state.allRtoDetails
                .filter(item => item && item.state)
                .map(item => item.state)
            )];
            state.allRtoDetails = uniqueStates;
            state.steps[0].alldata=state.allRtoDetails;
            state.formAlldata[0]["state"]=state.allRtoDetails;
          }
          
          if(state.steps[1].displayStepData == "city" && state.formData.state !="" && state.formData.city =="" ){
          state.allRtoDetails = [];
          nextStep();
          
          
          
          response.data.data.rto.forEach(city => {
            if (city && city.city) {
              state.allRtoDetails.push(city.city);
            }
          });
          state.allRtoDetails = [...new Set(
            state.allRtoDetails.filter(item => item != null && item !== '')
          )];
          state.steps[1].alldata=state.allRtoDetails;
          state.formAlldata[1]["city"]=state.allRtoDetails;
          } 
          if(state.steps[2].displayStepData == "rtoCode" &&  state.formData.state !="" && state.formData.city !="" && state.formData.rtoCode=="" && response.data.data.cityrto != undefined  && response.data.data.cityrto){
            state.allRtoDetails = [];
            if(state.searchfromhandlebutton){
              nextStep();
            }
          
          response.data.data.cityrto.forEach(cityrto => {
            if (cityrto && cityrto.rtoCode) {
              state.allRtoDetails.push(cityrto.rtoCode);
            }
          });
          const uniqueRtoCodes = [...new Set(
            state.allRtoDetails.filter(item => item != null && item !== '')
          )];
          state.allRtoDetails = uniqueRtoCodes;
          state.steps[2].alldata=state.allRtoDetails;
          state.formAlldata[2]["rtoCode"]=state.allRtoDetails;
          } 
          const makeList = response?.data?.data?.make;
          const shouldPopulateMakeList =
            state.category == "vehicle" &&
            Array.isArray(makeList) &&
            (state.itemClicked == "rtoCode" ||
              (state.itemClicked == "carMake" && !stepHasValidSelection(state.steps[3])));
          if (shouldPopulateMakeList) {
            state.allRtoDetails = [];
           
            if(state.searchfromhandlebutton){
            nextStep();
          }
          
            makeList.forEach(make => {
              if (make) {
                state.allRtoDetails.push(make);
              }
            });
            state.steps[3].alldata=state.allRtoDetails;
            state.formAlldata[3]["carMake"]=state.allRtoDetails; 
          } 
          if(state.category == "vehicle" && state.itemClicked =="carMake" && response.data.data.model != undefined  && response.data.data.model){
            state.allRtoDetails = [];
            
            if(state.searchfromhandlebutton){
            nextStep();
          }
          
            response.data.data.model.forEach(model => {
              if (model) {
                state.allRtoDetails.push(model);
              }
            });
            state.steps[4].alldata=state.allRtoDetails;
            state.formAlldata[4]["model"]=state.allRtoDetails; 
          } 
          if(state.category == "vehicle" && state.itemClicked =="model" && response.data.data.fuelType != undefined  && response.data.data.fuelType){
            state.allRtoDetails = [];
           
            if(state.searchfromhandlebutton && state.steps[5].iscompleted){
            nextStep();

             }
          response.data.data.fuelType.forEach(fuel => {
              if (fuel && fuel.fuelType) {
                state.allRtoDetails.push(fuel.fuelType);
              }
            });
            const uniqueFuelTypes = [...new Set(
              state.allRtoDetails.filter(item => item != null && item !== '')
            )];
            state.allRtoDetails = uniqueFuelTypes;
            state.steps[5].alldata=state.allRtoDetails;
            state.formAlldata[5]["fuelType"]=state.allRtoDetails;
            // if(state.allRtoDetails.length===1){
            //   state.formData["fuelType"] =state.allRtoDetails[0];
            //   state.steps[5].selectedItemvalue=state.allRtoDetails[0];
            //   state.formDataIndex[5].fuelType=state.allRtoDetails[0];
            //   console.log("state.formDataIndex",state.formDataIndex)
            //   state.userData = JSON.parse(sessionStorage.getItem("userData"));
            //   state.userData["fuelType"]=state.allRtoDetails[0];
            //   sessionStorage.setItem("userData",JSON.stringify(state.userData));
            //   state.steps[5].iscompleted = true;
            //   state.itemClicked ="fuelType";
            //   nextStep();
            //   searchVehicle();
                     
            // }
            if(state.allRtoDetails.length>0  && state.activeTab == '4' &&  state.itemClicked =="model" ) {
              nextStep()
            }
            sessionStorage.setItem("formAlldata",JSON.stringify(state.formAlldata)); 
        } 
        if(state.category == "vehicle" && state.itemClicked =="fuelType" && state.formData["variant"] ==''&& state.formData["fuelType"] !='' && response.data.data.variant != undefined  && response.data.data.variant ){
          state.allRtoDetails = [];
          
          if (state.searchfromhandlebutton) {
            nextStep();
          };
          response?.data?.data?.variant
          .forEach(variant => {
            console.log("variant",variant)
            if (variant) {
              state.allRtoDetails.push(variant);
            }
          });
          state.steps[6].alldata=state.allRtoDetails;
          state.formAlldata[6]["variant"]=state.allRtoDetails;               
            } 
          }
          if((state.category == "vehicle" && state.itemClicked =="variant") || (response.data.data.vehicleKey != undefined  && response.data.data.vehicleKey)){
            state.allRtoDetails = [];
              if(response.data.data.vehicleKey){
                state.vehicleKey = response.data.data.vehicleKey[0].vehicleKey;
                state.userData = JSON.parse(sessionStorage.getItem("userData"));
                state.userData["vehicleKey"]=state.vehicleKey;
                sessionStorage.setItem("vehicleKey",JSON.stringify(state.vehicleKey));
                sessionStorage.setItem("userData",JSON.stringify(state.userData));
                nextStep();
              }
                  sessionStorage.setItem("formAlldata",JSON.stringify(state.formAlldata));
          } 
        })
        .catch((error) => {
          console.log(">>>>>>>>>>>>>>>>error",error)
            const msg = "Service is Unavailable, Please try again later.";
            router.push({ path: '/error-page', query: { backUrl:'New-Journey', msg: msg,reqid:response?.data?.reqId } });
            state.loadingState=false;
        });
    }
    function isCompleted(index) {
      return index < state.activeTab;
    }
   function displayODSection() {
    state.vehicleAge = currentYearCalculated.value - state.registrationYear;
      if (state.motorProductType === '2W-Pvt') {
        return state.vehicleAge <= 5.10 || state.vehicleAge > 5.10;
      } else if (state.motorProductType === '4W-Pvt') {
        return state.vehicleAge <= 3.10 || state.vehicleAge > 3.10;
      }
      return false;
    }
    function displayTPSection() {
      state.vehicleAge = currentYearCalculated.value - state.registrationYear;

      if (state.motorProductType === '2W-Pvt') {
        return state.vehicleAge <= 5.10;
      } else if (state.motorProductType === '4W-Pvt') {
        return state.vehicleAge <= 3.10;
      }
      return false;
    }
    function isPreviousExpiryDate() {
      state.vehicleAge = currentYearCalculated.value - state.registrationYear;

      if (state.motorProductType === '2W-Pvt') {
        return state.vehicleAge > 5.10;
      } else if (state.motorProductType === '4W-Pvt') {
        return state.vehicleAge > 3.10;
      }
      return false;
    }
   
    function getNCBGridValue() {
      state.vehicleAge = currentYearCalculated.value - state.registrationYear;
      const age = state.vehicleAge;
      const ncbPercentage = {
        0:["0%"],
        1:["0%"],
        2:["0%", "20%"],
        3:["0%", "20%", "25%"],
        4:["0%", "20%"," 25%", "35%"],
        5:["0%", "20%","25%", "35%", "45%"],
        6:["0%", "20%","25%", "35%", "45%", "50%"]

      }
      // Use 6 as a key for age > 5
      const applicableAge = ["0%", "20%","25%", "35%", "45%", "50%"]; 
      return applicableAge;
    }
    
    /** Keeps searchVehicle branching (itemClicked) aligned with the visible step after arrow/sidebar navigation. */
    function syncItemClickedWithActiveTab() {
      const step = state.steps[state.activeTab];
      if (step && step.displayStepData) {
        state.itemClicked = step.displayStepData;
      }
    }

    function stepHasValidSelection(step) {
      const v = step.selectedItemvalue;
      if (v === null || v === undefined) return false;
      if (typeof v === 'string') return v.trim() !== '';
      if (typeof v === 'object') return Object.keys(v).length > 0;
      return true;
    }

    const nextStep = () => {
      if (state.activeTab < state.steps.length - 1) {
        state.activeTab += 1;
        syncItemClickedWithActiveTab();
      }
    };

    const previousStep = () => {
      if (state.activeTab > 0) {
        state.activeTab -= 1;
        syncItemClickedWithActiveTab();
      }
      if(state.activeTab == 0){
        router.go(-1);
      }
    };

    const selectTab = (index) => {
      console.log("index------------",index)
      if (state.steps[index]['iscompleted']) {
        state.activeTab = index;
        syncItemClickedWithActiveTab();
      }
      
      // Only clear steps after the current one
      for (let i = index+1; i < state.steps.length; i++) {
        // Don't mark steps as incomplete if they have valid selections
        // This allows forward navigation to work properly
        if (!state.steps[i].selectedItemvalue) {
          state.steps[i].iscompleted = false;
        }
        
        // Reset placeholders for steps after the current one
        if (i >= 3 && i <= 6) {
          if (state.motorProductType === '4W-Pvt') {
            if (i === 3 && !state.steps[i].selectedItemvalue) state.steps[i].carplaceholder = 'Search Car Make';
            if (i === 4 && !state.steps[i].selectedItemvalue) state.steps[i].carplaceholder = 'Search Car Model';
            if (i === 5 && !state.steps[i].selectedItemvalue) state.steps[i].carplaceholder = 'Select Car Fuel Type';
            if (i === 6 && !state.steps[i].selectedItemvalue) state.steps[i].carplaceholder = 'Search Car Variant';
          } else if (state.motorProductType === '2W-Pvt') {
            if (i === 3 && !state.steps[i].selectedItemvalue) state.steps[i].bikeplaceholder = 'Search Bike Make';
            if (i === 4 && !state.steps[i].selectedItemvalue) state.steps[i].bikeplaceholder = 'Search Bike Model';
            if (i === 5 && !state.steps[i].selectedItemvalue) state.steps[i].bikeplaceholder = 'Select Bike Fuel Type';
            if (i === 6 && !state.steps[i].selectedItemvalue) state.steps[i].bikeplaceholder = 'Search Bike Variant';
          }
        }
      }
      
      // Don't clear the selectedItemvalue for steps that have already been completed
      // This allows users to go back and forth without losing their selections
      
      const fields = [
        'state',
        'city',
        'rtoCode',
        'carMake',
        'model',
        'fuelType',
        'variant',
        'vehicleType',
        'makeCode',
      ];
      
      // Only clear form data for downstream fields when that step has no saved selection (avoids desync with steps[]).
      for (let i = index + 1; i < fields.length; i++) {
        if (i < state.steps.length && stepHasValidSelection(state.steps[i])) {
          continue;
        }
        state.formData[fields[i]] = '';
      }

      const userData = JSON.parse(sessionStorage.getItem('userData'));
      let trigger = index === 0 ? 'state'
        : index === 1 ? 'city'
        : index === 2 ? 'rto'
        : index === 3 ? 'carMake'
        : index === 4 ? 'carModel'
        : index === 5 ? 'fuelTypeStep'
        : index === 6 ? 'variantStep'
        : 'others';
      switch (trigger) {
        case 'state':
        case 'city':
          delete userData.rtoCode;
          delete userData.carMake;
          delete userData.model;
          delete userData.variant;
          delete userData.fuelType;
          delete userData.RegDate;
          delete userData.MfgYear;
          delete userData.OdDate;
          delete userData.TpDate;
          break;
        case 'rto':
          delete userData.carMake;
          delete userData.model;
          delete userData.variant;
          delete userData.fuelType;
          delete userData.RegDate
          delete userData.MfgYear
          delete userData.OdDate
          delete userData.TpDate
          break;
        case 'carMake':
          delete userData.model;
          delete userData.variant;
          delete userData.fuelType;
          delete userData.RegDate
          delete userData.MfgYear
          delete userData.OdDate
          delete userData.TpDate
          break;
        case 'carModel':
          delete userData.variant;
          delete userData.fuelType;
          delete userData.RegDate
          delete userData.MfgYear
          delete userData.OdDate
          delete userData.TpDate
          break;
        // Sidebar: fuel step (index 5) — clear only downstream, not fuelType
        case 'fuelTypeStep':
          delete userData.variant;
          delete userData.RegDate
          delete userData.MfgYear
          delete userData.OdDate
          delete userData.TpDate
          break;
        case 'variantStep':
          delete userData.RegDate
          delete userData.MfgYear
          delete userData.OdDate
          delete userData.TpDate
          break;
        case 'others':
          // delete userData.rtoCode;
          // delete userData.carMake;
          // delete userData.model;
          // delete userData.variant;
          // delete userData.fuelType;
          // delete userData.RegDate
          // delete userData.MfgYear
          // delete userData.OdDate
          // delete userData.TpDate
          break;
        default:
          break;
      }
      sessionStorage.setItem('userData', JSON.stringify(userData));
    };
    function openModalForVehicle(){
      state.openModalForVehicleEditing = true;
    }
    function closeModalEditing(){
      state.openModalForVehicleEditing = false;
    }
    function selectTabFromModal(index){
      selectTab(index)
    }
    function canMoveForward() {
      if (state.activeTab >= state.steps.length - 1) {
        return false;
      }
      const step = state.steps[state.activeTab];
      return !!(step.iscompleted && stepHasValidSelection(step));
    }
    
    function nextStepIfCompleted() {
      // Only move to the next step if current  step is completed
      if (canMoveForward()) {
        nextStep();
      }
    }
    return {
      state,
      completed,
      searchVehicle,
      isCompleted,
      nextStep,
      previousStep,
      selectTab,
      displayODSection,
      displayTPSection,
      isPreviousExpiryDate,
      getNCBGridValue,
      currentYearCalculated,
      handleItemClicked,
      openModalForVehicle,
      closeModalEditing,
      selectTabFromModal,
      canMoveForward,
      nextStepIfCompleted
    };
  },
  computed: {
  activeCarStepContent() {
    const raw = this.state.steps[this.state.activeTab].carsubcontent || '';
    return raw.replace(/<\/?b>/g, '');
  },
  activeBikeStepContent() {
    const raw = this.state.steps[this.state.activeTab].bikesubcontent || '';
    return raw.replace(/<\/?b>/g, '');
  }
}
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/form-wizard";
.editform{
  cursor: pointer;
}
.iconback{
  background: #f5f5f5;
  border-radius: 5px;
  padding: 5px;
  width:30px;
  text-align: center;
  cursor: pointer;
}
.disabled-icon {
  opacity: 0.5;
  cursor: not-allowed;
}
.selectrtosvg{
  width: 13px;
  height: 30px;
    
    
}
.dark{
  .editform img{
    filter: invert(1) !important;
  }
  .commonicon{
    filter: invert(1) !important;
  }
  .iconback{
  background: $bodyDarkBG;
  border-radius: 5px;
  padding: 5px;
  width:30px;
  text-align: center;
  cursor: pointer;
}
.selectrtosvg{
  
    filter: invert(1);
    width: 13px;
    height: 30px;
    
    
}
.activestepheader{
  color: $text-darkColorTransparent;
}
}
</style>
